import React from 'react'
import paymentImge from '../assets/images/payimage11.png'

export default function HeaderWelcome() {
  return (
    <div className='container  container--welcome'>
      <div className='row--welcome'>
        <h3 className='text-center text--welcome'>Welcome to STG ePay</h3>
        <h5 className='text-center textmuted text--tag'>
          Your payment portal for STG Orders
        </h5>
      </div>
      <div className='container'>
        <img
          className='mainpayImage'
          width='400'
          height='285'
          src={paymentImge}
          alt='ePay'
        />
      </div>
    </div>
  )
}
